import languageSelector from './language-selector.component'

const module = angular.module('ac.components.language-selector', [])

module.component('languageSelector', languageSelector)

export default module.name
